/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/banner_templates" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdBannerTemplatesCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdBannerTemplatesProps,
  PostEngagementAppGroupIdBannerTemplatesResult,
} from "./types";

export const postEngagementAppGroupIdBannerTemplates = reactQueryMutationAdapter(
  engagementAppGroupIdBannerTemplatesCacheKeys,
  (props: PostEngagementAppGroupIdBannerTemplatesProps): Promise<PostEngagementAppGroupIdBannerTemplatesResult> => {
    return fetch(`/engagement/${props.app_group_id}/banner_templates`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
